import React, { useState,useRef,useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Modal,
  Fade,
  Paper
} from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CloseIcon from '@mui/icons-material/Close';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
const VideoThumbnail = ({ video, onClick }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = 1; // Set to 1 second to get a good thumbnail frame
    }
  }, [video.url]);

  return (
    <Box sx={{ position: 'relative' }}>
      <video
        ref={videoRef}
        style={{
          width: '100%',
          height: '240px',
          objectFit: 'cover'
        }}
        src={video.url}
        preload="metadata"
        muted
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: 'rgba(0,0,0,0.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: 'rgba(0,0,0,0.5)',
          }
        }}
        onClick={onClick}
      >
        <PlayCircleIcon 
          sx={{ 
            fontSize: 60, 
            color: 'white',
            transition: 'transform 0.2s',
            '&:hover': {
              transform: 'scale(1.1)'
            }
          }} 
        />
      </Box>
    </Box>
  );
};

const Videos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isPlaying, setIsPlaying] = useState({});

  // Sample videos array - replace with your video paths
  const videos = [
    {
      id: 1,
      url: '/Gallery/1.mp4',
      thumbnail: '/thumbnail1.jpg',
      title: 'Amazing Sunset',
      description: 'Beautiful sunset captured in time-lapse'
    },
    {
      id: 2,
      url: '/Gallery/2.mp4',
      thumbnail: '/thumbnail1.jpg',
      title: 'Amazing Sunset',
      description: 'Beautiful sunset captured in time-lapse'
    },
    {
      id: 3,
      url: '/Gallery/3.mp4',
      thumbnail: '/thumbnail1.jpg',
      title: 'Amazing Sunset',
      description: 'Beautiful sunset captured in time-lapse'
    },
    {
      id: 4,
      url: '/Gallery/4.mp4',
      thumbnail: '/thumbnail1.jpg',
      title: 'Amazing Sunset',
      description: 'Beautiful sunset captured in time-lapse'
    },
    {
      id: 5,
      url: '/Gallery/5.mp4',
      thumbnail: '/thumbnail1.jpg',
      title: 'Amazing Sunset',
      description: 'Beautiful sunset captured in time-lapse'
    },
    
    // Add more videos as needed
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  const handleVideoPlay = (videoId) => {
    setIsPlaying(prev => ({
      ...prev,
      [videoId]: !prev[videoId]
    }));
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography 
          variant="h2" 
          align="center"
          sx={{
            mb: 6,
            fontWeight: 'bold',
            background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',

            // background: 'linear-gradient(45deg, #FF4081 30%, #FF80AB 90%)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Video Gallery
        </Typography>
      </motion.div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <Grid container spacing={3}>
          {videos.map((video) => (
            <Grid item xs={12} sm={6} md={4} key={video.id}>
              <motion.div variants={itemVariants}>
                <Card 
                  sx={{ 
                    position: 'relative',
                    transition: '0.3s',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
                    }
                  }}
                >
                  <VideoThumbnail 
                    video={video} 
                    onClick={() => setSelectedVideo(video)} 
                  />
                  {/* <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {video.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {video.description}
                    </Typography>
                  </CardContent> */}
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>

      <Modal
        open={!!selectedVideo}
        onClose={() => {
          setSelectedVideo(null);
          setIsPlaying({});
        }}
        closeAfterTransition
      >
        <Fade in={!!selectedVideo}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '90vw',
              maxHeight: '90vh',
              outline: 'none'
            }}
          >
            <Paper elevation={24}>
              <Box sx={{ position: 'relative' }}>
                <IconButton
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: 'white',
                    bgcolor: 'rgba(0,0,0,0.5)',
                    zIndex: 1,
                    '&:hover': {
                      bgcolor: 'rgba(0,0,0,0.7)'
                    }
                  }}
                  onClick={() => {
                    setSelectedVideo(null);
                    setIsPlaying({});
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <Box sx={{ position: 'relative' }}>
                  <video
                    src={selectedVideo?.url}
                    controls
                    style={{
                      maxWidth: '90vw',
                      maxHeight: '80vh',
                      display: 'block'
                    }}
                    autoPlay
                  />
                </Box>
              </Box>
            </Paper>
          </Box>
        </Fade>
      </Modal>
    </Container>
  );
};

export default Videos;
// {
//   id: 2,
//   url: '/video-2.mp4',
//   thumbnail: '/thumbnail1.jpg',
//   title: 'Amazing Sunset',
//   description: 'Beautiful sunset captured in time-lapse'
// },
// {
//   id: 3,
//   url: '/video-3.mp4',
//   thumbnail: '/thumbnail1.jpg',
//   title: 'Amazing Sunset',
//   description: 'Beautiful sunset captured in time-lapse'
// },
// {
//   id: 4,
//   url: '/video-4.mp4',
//   thumbnail: '/thumbnail1.jpg',
//   title: 'Amazing Sunset',
//   description: 'Beautiful sunset captured in time-lapse'
// },
// {
//   id: 5,
//   url: '/video-5.mp4',
//   thumbnail: '/thumbnail1.jpg',
//   title: 'Amazing Sunset',
//   description: 'Beautiful sunset captured in time-lapse'
// },
// {
//   id: 6,
//   url: '/video-6.mp4',
//   thumbnail: '/thumbnail1.jpg',
//   title: 'Amazing Sunset',
//   description: 'Beautiful sunset captured in time-lapse'
// },